import 'formstone/dist/js/core';
import 'formstone/dist/js/mediaquery';
import 'formstone/dist/js/swap';
import 'formstone/dist/js/touch';
import 'formstone/dist/js/transition';
import 'formstone/dist/js/cookie';
